<template>
    <div id="Cart">
        <div class="headerbg">
            <b-container class="d-flex align-items-center justify-content-between">
                <h1 class="cart-title">購物車列表
                    <b-badge v-if="List.length" pill variant="light" class="cart-count-badge">{{ List.length }}</b-badge>
                </h1>
                <b-button class="text-nowrap" variant="outline-secondary" size="sm" :to="{ name: 'CampCart' }">
                    <b-icon-arrow-left-right class="mr-1"></b-icon-arrow-left-right><strong>營隊</strong> ({{ campCartCount }})
                </b-button>
            </b-container>
        </div>
        <b-container v-if="Step == 1">
            <b-row class="mb-3 ">
                <b-col cols="12">
                    <b-card class="mb-3" title="">
                        <b-row class="d-flex flex-wrap p-0">
                            <b-col cols="6" class="font-weight-bold text-nowrap">課程名稱</b-col>
                            <b-col cols="2" class="font-weight-bold text-nowrap">數量</b-col>
                            <b-col cols="2" class="font-weight-bold text-nowrap">價格</b-col>
                            <b-col cols="1" class="font-weight-bold text-center text-nowrap">操作</b-col>
                            <b-col cols="12">
                                <hr />
                            </b-col>
                        </b-row>
                        <b-row v-for="(item, index) in List" :key="index" class="d-flex flex-wrap p-0">
                            <b-col cols="6" class="">{{ item.ProductName }}</b-col>
                            <b-col cols="2">{{ item.Quantity }}</b-col>
                            <b-col cols="2">{{ item.DiscountPrice | money(0, 2) }}</b-col>
                            <b-col cols="1" class="text-center px-0">
                                <b-button class="text-nowrap btn-sm" variant="outline-danger"
                                    @click="DeleteCart(item.Id)">刪除</b-button>
                            </b-col>
                            <b-col cols="12" md="12" v-if="index + 1 != CheckOutItem.CartDto.length">
                                <hr />
                            </b-col>
                        </b-row>

                        <b-alert show v-if="cartLoadError" variant="danger">購物車載入失敗，請稍後再試。</b-alert>
                        <b-alert show v-else-if="List.length == 0" variant="primary">購物車目前沒有東西唷！</b-alert>
                    </b-card>
                </b-col>
            </b-row>
            <b-row v-if="List.length > 0">
                <b-col cols="12" class="d-flex justify-content-end mb-5">
                    <b-button variant="primary " @click="ToCheckOut">下一步</b-button>
                </b-col>
            </b-row>
        </b-container>
        <b-container v-if="Step == 2">
            <b-row class="mb-3 ">
                <b-col cols="12">
                    <b-card class="mb-3" title="">
                        <b-row class="d-flex flex-wrap">
                            <b-col cols="6" md="7" class="font-weight-bold text-nowrap">課程名稱</b-col>
                            <!-- <b-col cols="3">上課時間</b-col> -->
                            <b-col cols="2" class="font-weight-bold text-nowrap">數量</b-col>
                            <b-col cols="2" class="font-weight-bold text-nowrap">價格</b-col>
                            <b-col cols="1" class="font-weight-bold text-nowrap">操作</b-col>
                            <b-col cols="12">
                                <hr />
                            </b-col>
                        </b-row>
                        <b-row v-for="(item, index) in CheckOutItem.CartDto" :key="index" class="d-flex flex-wrap">
                            <b-col cols="6" md="7">
                                {{ item.ProductName }}
                            </b-col>
                            <!-- <b-col cols="3">
                                {{ item.Start | datefmt('YYYY/MM/DD') }}~ {{ item.End | datefmt('YYYY/MM/DD') }}</b-col
                            > -->
                            <b-col cols="2">{{ item.Quantity }}</b-col>
                            <b-col cols="2">{{ item.DiscountPrice | money(0, 2) }}</b-col>
                            <b-col cols="1">
                                <b-icon-trash-fill variant="danger" class="btn btn-sm"
                                    @click="DeleteCart(item.Id)"></b-icon-trash-fill>
                            </b-col>
                            <b-col cols="12" md="12" v-if="index + 1 != List.length">
                                <hr />
                            </b-col>
                        </b-row>
                        <b-col cols="12" style="height: 2px;background:#000" class="my-3"> </b-col>
                        <b-row class="d-flex justify-content-end flex-wrap px-0">
                            <div style="min-width: 440px;">
                                <b-col md="12" class="d-flex align-items-center justify-content-between">
                                    <span class="font-weight-bold">原價：</span>
                                    <span class="d-flex">$
                                        <span class="text-end" style="min-width: 61px;text-align: end;">{{
                                            CheckOutItem.ProductPrice | money(0, 2)
                                        }}</span></span>
                                </b-col>
                                <b-col md="12" class="d-flex align-items-center justify-content-between">
                                    <span class="font-weight-bold">折扣金額：</span>
                                    <span class="d-flex">
                                        <b-badge id="tooltip-target-1" variant="success" class="mr-2 cursor-default">{{
                                            CheckOutItem.PromoteDto.PromotionName
                                        }}</b-badge>
                                        <b-tooltip target="tooltip-target-1" triggers="hover">
                                            <b>優惠名稱</b>
                                        </b-tooltip>
                                        $
                                        <span class="text-end" style="min-width: 61px;text-align: end;">{{
                                            CheckOutItem.PromoteDto.Discount | money(0, 2)
                                        }}</span>
                                    </span>
                                </b-col>
                            </div>
                        </b-row>
                        <b-col cols="12" style="height: 1px;background:#000" class="my-3"> </b-col>
                        <!-- <b-col md="12" class="text-right" v-if="!CheckOutItem.PromoteDto || !CheckOutItem.PromoteDto.PromotionName">無折扣</b-col>
                        <div v-else>
                            <b-col md="12" class="text-right px-0" v-for="(p,i) in CheckOutItem.PromoteDto" :key="i">
                                折扣活動：{{ CheckOutItem.PromoteDto.PromotionName || '—' }}
                                <div>折扣金額：$ {{ (CheckOutItem.PromoteDto.Discount || 0) | money(0,2) }}</div>
                            </b-col>
                        </div> -->
                        <b-col cols="12" class="d-flex justify-content-end">
                            <b-col md="12" class="text-right px-0">總計：$ {{ CheckOutItem.TotalPrice | money(0, 2) }}
                            </b-col>
                        </b-col>
                    </b-card>
                </b-col>
            </b-row>
            <b-row class="mb-3 ">
                <b-col cols="12">
                    <b-card class="mb-3" title="">
                        <b-form>
                            <b-row>
                                <b-col>
                                    <b-form-group label-for="first-name">
                                        <template #label>
                                            <span class="d-inline-flex align-items-center">
                                                <b-badge variant="danger" class="mt-1 mr-2">必填</b-badge>
                                                姓
                                            </span>
                                        </template>
                                    <b-form-input id="first-name" v-model="CheckOutItem.MemberInfo.FirstName"
                                            type="text" placeholder="姓" required
                                            :state="getFieldState('FirstName')"
                                            @input="onFieldInput('FirstName')" />
                                        <b-form-invalid-feedback v-if="submitAttempted && formErrors.FirstName">
                                            {{ formErrors.FirstName }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </b-col>
                                <b-col>
                                    <b-form-group label-for="last-name">
                                        <template #label>
                                            <span class="d-inline-flex align-items-center">
                                                <b-badge variant="danger" class="mt-1 mr-2">必填</b-badge>
                                                名
                                            </span>
                                        </template>
                                    <b-form-input id="last-name" v-model="CheckOutItem.MemberInfo.LastName"
                                            type="text" placeholder="名" required
                                            :state="getFieldState('LastName')"
                                            @input="onFieldInput('LastName')" />
                                        <b-form-invalid-feedback v-if="submitAttempted && formErrors.LastName">
                                            {{ formErrors.LastName }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </b-col>
                            </b-row>

                            <b-form-group :state="getFieldState('Gender')">
                                <template #label>
                                    <b-badge variant="danger  mt-1 mr-2">必填 </b-badge>
                                    性別
                                </template>
                                <b-row>
                                    <b-col>
                                        <b-form-radio v-model="CheckOutItem.MemberInfo.Gender" name="some-radios"
                                            value="0" @change="onFieldInput('Gender')"
                                            :state="getFieldState('Gender')">男</b-form-radio></b-col>
                                    <b-col>
                                        <b-form-radio v-model="CheckOutItem.MemberInfo.Gender" name="some-radios"
                                            value="1" @change="onFieldInput('Gender')"
                                            :state="getFieldState('Gender')">女</b-form-radio>
                                    </b-col></b-row>
                                <b-form-invalid-feedback v-if="submitAttempted && formErrors.Gender">
                                    {{ formErrors.Gender }}
                                </b-form-invalid-feedback>
                            </b-form-group>
                            <b-form-group>
                                <template #label>
                                    <b-badge variant="danger  mt-1 mr-2">必填</b-badge>
                                    電話
                                </template>
                                <b-row>
                                    <b-col>
                                        <b-form-input id="input-1" v-model="CheckOutItem.MemberInfo.Phone"
                                            placeholder="電話" required
                                            :state="getFieldState('Phone')"
                                            @input="onFieldInput('Phone')"></b-form-input>
                                        <b-form-invalid-feedback v-if="submitAttempted && formErrors.Phone">
                                            {{ formErrors.Phone }}
                                        </b-form-invalid-feedback>
                                    </b-col>
                                </b-row>
                            </b-form-group>
                            <b-form-group>
                                <template #label>
                                    <b-badge variant="danger  mt-1 mr-2">必填</b-badge>
                                    Email
                                </template>
                                <b-row>
                                    <b-col>
                                        <b-form-input id="input-1" v-model="CheckOutItem.MemberInfo.Email"
                                            placeholder="Email" required
                                            :state="getFieldState('Email')"
                                            @input="onFieldInput('Email')"></b-form-input>
                                        <b-form-invalid-feedback v-if="submitAttempted && formErrors.Email">
                                            {{ formErrors.Email }}
                                        </b-form-invalid-feedback>
                                    </b-col>
                                </b-row>
                            </b-form-group>
                            <b-form-group>
                                <template #label>
                                    <b-badge variant="danger  mt-1 mr-2">必填</b-badge>
                                    地址
                                </template>
                                <b-row class="mb-3">
                                    <b-col>
                                        <b-form-select id="input-3" @change="ChangeCity"
                                            v-model="CheckOutItem.MemberInfo.City" required
                                            :state="getFieldState('City')"
                                            @input="onFieldInput('City')">
                                            <b-form-select-option :value="item.Name" v-for="item in CityList"
                                                :key="item.Id">
                                                {{ item.Name }}
                                            </b-form-select-option>
                                        </b-form-select>
                                        <b-form-invalid-feedback v-if="submitAttempted && formErrors.City">
                                            {{ formErrors.City }}
                                        </b-form-invalid-feedback>
                                    </b-col>
                                    <b-col>
                                        <b-form-select v-model="CheckOutItem.MemberInfo.Town"
                                            :disabled="!TownList.length" required
                                            :state="getFieldState('Town')"
                                            @input="onFieldInput('Town')">
                                            <b-form-select-option :value="''" disabled>請選擇鄉鎮</b-form-select-option>
                                            <b-form-select-option :value="item.Name" v-for="item in TownList"
                                                :key="item.Id">
                                                {{ item.Name }}
                                            </b-form-select-option>
                                        </b-form-select>
                                        <b-form-invalid-feedback v-if="submitAttempted && formErrors.Town">
                                            {{ formErrors.Town }}
                                        </b-form-invalid-feedback>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col cols="12">
                                        <b-form-input id="input-1" v-model="CheckOutItem.MemberInfo.Address"
                                            placeholder="地址" required
                                            :state="getFieldState('Address')"
                                            @input="onFieldInput('Address')"></b-form-input>
                                        <b-form-invalid-feedback v-if="submitAttempted && formErrors.Address">
                                            {{ formErrors.Address }}
                                        </b-form-invalid-feedback>
                                    </b-col>
                                </b-row>
                            </b-form-group>
                        </b-form>
                    </b-card>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" class="d-flex justify-content-end mb-5">
                    <b-button variant="primary " @click="ToOrder">訂單確定</b-button>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>
<script>
import {
    apiCheckMember,
    apiGetCart,
    apiToCheckOut,
    apiDeleteCart,
    // apiDictionary,
    // apiDictionarySelector,
    apiToOrder,
    // apiGetMember,
    apiGetCityTown,
} from '@/api/API.js';
// import axios from 'axios';

export default {
    name: 'Cart',

    data() {
        return {
            Step: 1,
            List: [],
            CheckOutItem: {
                CartDto: [],
                MemberInfo: { City: '', Town: '', Address: '' },
                PromoteDto: [],
                ProductPrice: 0,
                TotalPrice: 0,
            },
            CityList: [],
            TownList: [],
            PromoteList: '',
            cartLoadError: false,
            submitAttempted: false,
            formErrors: {},
        };
    },

    computed: {
        campCartCount() { return this.$store.getters['campCart/totalCount']; },
    },
    mounted() {
        apiCheckMember()
            .then(() => {
                this.Init();
                this.$store.dispatch('campCart/fetchCart');
            })
            .catch((err) => {
                alert('尚未登入');
                console.log(err);
                this._go('/');
            });
        this.modal_init(this.modal_set);
        let navBgSwitch = this._storeData('navBgSwitch');
        if (this.IsNull(navBgSwitch) != '') {
            navBgSwitch(false);
        }
        // this.sessionF1();
    },
    watch: {
        'CheckOutItem.MemberInfo.City'(newVal) {
            if (!newVal) {
                this.TownList = [];
                return;
            }
            const city = this.CityList.find((c) => c.Name === newVal || c.text === newVal);
            if (!city) return;

            this.ChangeCity();
        },
    },
    methods: {
        Init() {
            this.Step = 1;
            this.cartLoadError = false;
            this.submitAttempted = false;
            this.formErrors = {};
            // 取城市
            apiGetCityTown({
                Paging: { pageSize: 9999, pageNumber: 1 },
                Search: { keywords: 'city' }, // 你現有 API 的寫法
            })
                .then((res) => {
                    this.CityList = res.data || [];
                })
                .catch(console.log);
            apiGetCart()
                .then((res) => {
                    const groups = Array.isArray(res.data) ? res.data : [];
                    this.List = (groups[0] && Array.isArray(groups[0].CartDto)) ? groups[0].CartDto : [];
                    this.cartLoadError = false;
                    // this.CheckOutItem = res.data[0];
                    // apiGetMember()
                    //     .then((res) => {
                    //         this.CheckOutItem.MemberInfo = {
                    //             UserId: res.data.UserId,
                    //             FirstName: res.data.User.FirstName,
                    //             LastName: res.data.User.LastName,
                    //             EnglishName: res.data.User.NickName,
                    //             Gender: res.data.Gender,
                    //             Phone: res.data.Phone,
                    //             Address: res.data.Address,
                    //             Email: res.data.Email,
                    //             City: res.data.City,
                    //             Town: res.data.Town,
                    //         };
                    //     })
                    //     .catch((err) => {
                    //         console.log(err);
                    //     });
                    // console.log(this.CheckOutItem);
                })
                .catch((err) => {
                    console.log(err);
                    //alert(err.response.data);
                    this.List = [];
                    this.cartLoadError = true;
                });
        },
        async ensureCityList() {
            if (this.CityList && this.CityList.length) return;
            const { data } = await apiGetCityTown({
                Paging: { pageSize: 9999, pageNumber: 1 },
                Search: { keywords: 'city' },
            });
            this.CityList = data || [];
        },

        async loadTownsByCityName(cityName, { keepTown = true } = {}) {
            // 確保 CityList 已載入
            await this.ensureCityList();

            // 找出目前選到的城市
            const city = this.CityList.find((c) => c.Name === cityName);
            this.TownList = [];
            if (!city) {
                // 城市不在清單，直接清空 Town
                this.CheckOutItem.MemberInfo.Town = '';
                return;
            }

            const { data } = await apiGetCityTown({
                Paging: { pageSize: 9999, pageNumber: 1 },
                Search: { keywords: 'town' },
            });
            const allTowns = data || [];
            this.TownList = allTowns.filter((t) => t.Fk === city.Id);

            const prevTown = this.CheckOutItem.MemberInfo.Town || '';
            if (keepTown && prevTown && this.TownList.some((t) => t.Name === prevTown)) {
                // 舊值有效就保留
                return;
            }
            this.CheckOutItem.MemberInfo.Town = '';
        },

        ChangeCity() {
            this.loadTownsByCityName(this.CheckOutItem.MemberInfo.City, { keepTown: false });
        },

        validateMemberInfo() {
            const member = this.CheckOutItem?.MemberInfo || {};
            const errors = {};
            const firstName = (member.FirstName || '').trim();
            const lastName = (member.LastName || '').trim();
            const phone = (member.Phone || '').trim();
            const email = (member.Email || '').trim();
            const city = (member.City || '').trim();
            const town = (member.Town || '').trim();
            const address = (member.Address || '').trim();
            const gender = member.Gender;

            if (!firstName) errors.FirstName = '請填寫姓';
            if (!lastName) errors.LastName = '請填寫名';
            if (gender === '' || gender === null || typeof gender === 'undefined') {
                errors.Gender = '請選擇性別';
            }
            if (!phone) errors.Phone = '請填寫電話';
            if (!email) {
                errors.Email = '請填寫 Email';
            } else if (!/^\S+@\S+\.\S+$/.test(email)) {
                errors.Email = 'Email 格式不正確';
            }
            if (!city) errors.City = '請選擇城市';
            if (city && !town) errors.Town = '請選擇鄉鎮';
            if (!address) errors.Address = '請填寫地址';

            return errors;
        },

        getFieldState(field) {
            if (!this.submitAttempted) return null;
            return this.formErrors[field] ? false : true;
        },

        onFieldInput() {
            if (!this.submitAttempted) return;
            this.formErrors = this.validateMemberInfo();
        },

        async ToCheckOut() {
            if (!this.List.length || !this.List[0]?.ProductDep) return;
            try {
                const { data } = await apiToCheckOut(this.List[0].ProductDep);

                // 只做一件事：沒促銷時補一個空物件，避免模板 access null
                if (!data.PromoteDto) {
                    data.PromoteDto = { PromotionId: null, PromotionName: '', Discount: 0, Products: [] };
                } else if (!Array.isArray(data.PromoteDto.Products)) {
                    data.PromoteDto.Products = []; // 確保是陣列，符合 Swagger
                }

                this.CheckOutItem = data; // 其它都原封不動
                this.Step = 2;
                this.submitAttempted = false;
                this.formErrors = {};
            } catch (e) {
                console.log(e);
            }
        },
        DeleteCart(id) {
            var yes = confirm('確定移除此項目？');
            if (yes) {
                apiDeleteCart(id)
                    .then(() => {
                        this.CheckOutItem = {};
                        alert('刪除成功');
                        this.$store.dispatch('courseCart/fetchCount');
                        apiToCheckOut(this.List[0].ProductDep)
                            .then((res) => {
                                if (this.CheckOutItem.CartDto.length == 0) {
                                    this.Init();
                                } else {
                                    this.CheckOutItem = res.data;
                                }
                            })
                            .catch((err) => {
                                console.log(err);
                                this.Init();
                            });
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }
        },
        ToOrder() {
            this.submitAttempted = true;
            this.formErrors = this.validateMemberInfo();
            if (Object.keys(this.formErrors).length) {
                return;
            }
            const {
                Department = 'All',
                CartDto = [],
                PromoteDto = { PromotionId: null, PromotionName: '', Discount: 0, Products: [] },
                MemberInfo = {},
            } = this.CheckOutItem || {};

            // this.CheckOutItem.MemberInfo.Town = this.Town || this.CheckOutItem.MemberInfo.Town || '';

            const payload = {
                Department,
                CartDto,
                PromoteDto: {
                    PromotionId: PromoteDto.PromotionId || null,
                    PromotionName: PromoteDto.PromotionName || '',
                    Discount: Number(PromoteDto.Discount) || 0,
                    Products: Array.isArray(PromoteDto.Products) ? PromoteDto.Products : [],
                },
                MemberInfo: {
                    ...MemberInfo,
                    Gender: Number(MemberInfo.Gender) || 0, // radio 可能是字串，轉數字
                },
            };

            apiToOrder(payload)
                .then(() => {
                    alert('加入訂單成功');
                    this.Init();
                    this._go('/order');
                })
                .catch((err) => {
                    console.log(err);
                });
        },
    },
};
</script>
<style lang="scss">
#Cart {
    .cart-title {
        display: inline-flex;
        align-items: center;
        gap: 0.5rem;
        font-size: 1.8rem;
        white-space: nowrap;
    }

    .cart-count-badge {
        border: 1px solid currentColor;
        background-color: #fff !important;
        color: #007ac2;
        font-size: 0.85rem;
        line-height: 1;
    }

    .custom-control-label {
        width: 100% !important;
    }

    @media (max-width: 799.98px) {
        .cart-title {
            font-size: 1.6rem;
        }
    }
}
</style>
